import { Link } from 'react-router-dom';
import { useState } from 'react';
import './Courses.css';
import CourseModal from '../components/CourseModal';

const courses = [
  // ─── STOCK MARKET INSTITUTE ───────────────────────────────────────────────
  {
    id: 8, category: 'Institute', level: 'Beginner', badge: 'Weekend Course',
    title: 'Technical Analysis', hours: '3 Months', type: 'Weekend Classes',
    lang: 'Hindi + English', price: '₹10,999', chartType: 'candle',
    desc: 'Learn to read charts, identify candlestick patterns, use technical indicators and build profitable trading strategies with live market examples every weekend.',
    syllabus: [
      'Introduction to Technical Analysis & Dow Theory',
      'Japanese candlestick patterns — Doji, Hammer, Engulfing',
      'Support, resistance & trend line drawing',
      'Moving Averages — SMA, EMA & crossover strategies',
      'RSI, MACD & Bollinger Bands in depth',
      'Volume analysis & On Balance Volume (OBV)',
      'Chart patterns — Head & Shoulders, Double Top/Bottom',
      'Cup & Handle, Flags, Pennants & Wedges',
      'Fibonacci retracement & extension levels',
      'Entry, exit & stop loss rule building',
      'Risk management & position sizing',
      'Building your own complete trading system',
    ],
  },
  {
    id: 9, category: 'Institute', level: 'Beginner', badge: 'Weekend Course',
    title: 'Fundamental Analysis', hours: '3 Months', type: 'Weekend Classes',
    lang: 'Hindi + English', price: '₹10,999', chartType: 'bar',
    desc: 'Understand how to evaluate companies through financial statements, ratios and valuation models to identify strong stocks for long-term wealth creation.',
    syllabus: [
      'Introduction to fundamental analysis & value investing',
      'Understanding Balance Sheet, P&L and Cash Flow',
      'Key financial ratios — P/E, P/B, ROE, ROCE, D/E',
      'Revenue, profit margin & earnings growth analysis',
      'Industry & sector analysis framework',
      'Competitive moat — identifying strong businesses',
      'DCF (Discounted Cash Flow) valuation method',
      'Relative valuation — comparing peers',
      'Management quality & corporate governance',
      'Identifying multibagger stocks for long term',
      'Building a fundamental stock screening checklist',
      'Portfolio construction & diversification strategy',
    ],
  },
  {
    id: 10, category: 'Institute', level: 'Beginner', badge: 'Weekend Course',
    title: 'Mutual Fund Investing', hours: '3 Months', type: 'Weekend Classes',
    lang: 'Hindi + English', price: '₹10,999', chartType: 'area',
    desc: 'Master mutual fund categories, SIP planning, portfolio diversification, risk assessment and how to select the right funds for your financial goals.',
    syllabus: [
      'What are mutual funds — structure & types',
      'Equity, Debt, Hybrid & Index funds explained',
      'NAV, expense ratio, exit load — key concepts',
      'SIP vs Lumpsum — when to use which',
      'Risk profiling — conservative, moderate, aggressive',
      'SEBI categorisation of mutual funds',
      'How to read a fund factsheet',
      'Selecting top performing funds — criteria',
      'Direct vs Regular plans — cost difference',
      'Tax on mutual funds — STCG, LTCG, ELSS',
      'Rebalancing & reviewing your portfolio',
      'Goal-based investing — retirement, education, house',
    ],
  },
  {
    id: 11, category: 'Institute', level: 'Intermediate', badge: 'Weekend Course',
    title: 'Crypto Trading', hours: '3 Months', type: 'Weekend Classes',
    lang: 'Hindi + English', price: '₹10,999', chartType: 'candle',
    desc: 'Introduction to blockchain, cryptocurrency markets, crypto trading strategies, risk management in volatile markets and understanding DeFi and Web3 basics.',
    syllabus: [
      'Blockchain technology & how it works',
      'Bitcoin, Ethereum & top altcoins overview',
      'Crypto exchanges — centralised vs decentralised',
      'Wallets — hot wallet vs cold wallet security',
      'Reading crypto charts & price action',
      'Technical analysis applied to crypto markets',
      'Key indicators for crypto — MVRV, NVT, Fear & Greed',
      'Spot trading vs futures trading in crypto',
      'DeFi — decentralised finance explained',
      'Risk management in highly volatile crypto markets',
      'Tax on crypto in India — legal framework',
      'Building a crypto portfolio safely',
    ],
  },
  // ─── NCFM ─────────────────────────────────────────────────────────────────
  {
    id: 1, category: 'NCFM', level: 'Beginner', badge: 'NCFM',
    title: 'Capital Market Module', hours: '40 Hours', type: 'Exam Prep',
    lang: 'Hindi + English', price: '₹8,999', chartType: 'bar',
    desc: 'Covers Indian securities market overview, trading mechanisms on NSE, clearing & settlement processes, legal framework and fundamental valuation concepts for aspiring dealers.',
    syllabus: [
      'Overview of Indian Securities Market — structure & segments',
      'Trading membership — stock brokers & sub-brokers',
      'NSE NEAT trading system — order types & commands',
      'Market types — Normal, Odd Lot, Auction, Retail Debt',
      'Clearing & settlement — T+1 rolling settlement',
      'Risk management — VaR margins, MTM, exposure limits',
      'Depository system — NSDL, CDSL & demat accounts',
      'SEBI legal framework — SCRA 1956, SEBI Act 1992',
      'Investor grievance & arbitration mechanism',
      'Fundamental valuation concepts — EPS, P/E, book value',
      'Mock exam practice — 60 MCQ pattern (50% pass)',
      'Exam registration guidance — NSE certification portal',
    ],
  },
  {
    id: 2, category: 'NCFM', level: 'Advanced', badge: 'NCFM',
    title: 'Options Trading Strategies', hours: '50 Hours', type: 'Live Sessions',
    lang: 'Hindi + English', price: '₹12,999', chartType: 'candle',
    desc: 'Deep dive into options pricing, Greeks (Delta, Gamma, Theta, Vega), hedging strategies, spreads and practical options setups for consistent profitability.',
    syllabus: [
      'Options basics — call, put, premium, strike price, expiry',
      'Intrinsic value vs time value of options',
      'Option Greeks — Delta, Gamma, Theta, Vega, Rho',
      'Black-Scholes model & options pricing',
      'Implied Volatility (IV) & VIX — reading the market',
      'Bullish strategies — Bull Call Spread, Bull Put Spread',
      'Bearish strategies — Bear Put Spread, Bear Call Spread',
      'Neutral strategies — Iron Condor, Butterfly, Straddle, Strangle',
      'Hedging with options — portfolio protection',
      'Weekly vs monthly expiry strategy building',
      'Options chain analysis & open interest interpretation',
      'Live paper trading sessions — practical implementation',
    ],
  },
  {
    id: 3, category: 'NCFM', level: 'Intermediate', badge: 'NCFM',
    title: 'Technical Analysis Module', hours: '45 Hours', type: 'Chart Practice',
    lang: 'Hindi + English', price: '₹10,999', chartType: 'candle',
    desc: 'Chart patterns, candlestick analysis, indicators (RSI, MACD, Bollinger Bands), support & resistance, price action and building a complete trading system.',
    syllabus: [
      'Dow Theory & principles of technical analysis',
      'Japanese candlestick patterns — single & multi-candle',
      'Support, resistance, trend lines & channels',
      'Moving Averages — SMA, EMA, crossovers',
      'Oscillators — RSI, MACD, Stochastic',
      'Bollinger Bands & ATR for volatility analysis',
      'Volume analysis — accumulation & distribution',
      'Chart patterns — continuation & reversal patterns',
      'Point & Figure charts, Renko charts',
      'Elliott Wave Theory — basics & application',
      'System building — rules for entry, exit, SL & target',
      'Mock test preparation — NCFM pattern',
    ],
  },
  {
    id: 4, category: 'NCFM', level: 'Intermediate', badge: 'NCFM',
    title: 'Fundamental Analysis Module', hours: '45 Hours', type: 'Case Studies',
    lang: 'Hindi + English', price: '₹10,999', chartType: 'bar',
    desc: 'Financial statement analysis, ratio analysis, company valuation methods (DCF, P/E, P/B), industry analysis and identifying multibagger stocks for long-term investing.',
    syllabus: [
      'Introduction to fundamental analysis — top-down approach',
      'Macroeconomic analysis — GDP, inflation, interest rates',
      "Industry analysis — Porter's Five Forces",
      'Balance sheet analysis — assets, liabilities, equity',
      'Income statement — revenue, EBITDA, PAT analysis',
      'Cash flow statement — operating, investing, financing',
      'Key ratios — P/E, P/B, EV/EBITDA, ROE, ROCE, D/E',
      'DCF valuation — free cash flow model',
      'Relative valuation — peer comparison',
      'Management quality & corporate governance checks',
      'Annual report reading — MD&A, notes to accounts',
      'Building a stock screening & watchlist framework',
    ],
  },
  // ─── NISM ─────────────────────────────────────────────────────────────────
  {
    id: 5, category: 'NISM', level: 'Advanced', badge: 'NISM Series VIII',
    title: 'Equity Derivatives Certification', hours: '50 Hours', type: 'Live Trading',
    lang: 'Hindi + English', price: '₹12,999', chartType: 'candle',
    desc: 'Futures & options on equities and indices, derivative pricing, risk management, hedging, arbitrage strategies and SEBI regulatory framework. Mandatory for F&O dealers.',
    syllabus: [
      'Basics of derivatives — evolution & Indian derivatives market',
      'Market participants — hedgers, speculators, arbitrageurs',
      'Understanding index — Nifty, Sensex construction',
      'Introduction to Forwards & Futures — pricing, settlement',
      'Futures payoff — long & short futures strategies',
      'Introduction to Options — calls, puts, premium',
      'Options pricing — intrinsic value, time value, Black-Scholes',
      'Option trading strategies — covered call, protective put',
      'Introduction to trading systems — order types, NSE platform',
      'Clearing & settlement — NSCCL, margins, MTM',
      'Legal & regulatory environment — SEBI Act, SC(R)A',
      'Accounting, taxation & investor protection',
    ],
  },
  {
    id: 6, category: 'NISM', level: 'Intermediate', badge: 'NISM Series VII',
    title: 'Securities Operations & Risk Management', hours: '40 Hours', type: 'Exam Prep',
    lang: 'Hindi + English', price: '₹8,999', chartType: 'bar',
    desc: 'Trade lifecycle, back-office operations, clearing & settlement, risk controls, compliance framework and operational risk management in securities markets.',
    syllabus: [
      'Securities market — structure, participants & instruments',
      'Trade life cycle — order, execution, confirmation, settlement',
      'Clearing process — clearing members, netting, obligations',
      'Settlement — rolling settlement T+1, pay-in & pay-out',
      'Depository operations — NSDL, CDSL, demat accounts',
      'Corporate actions — dividends, bonus, rights, splits',
      'Risk management — credit risk, market risk, operational risk',
      'Margins — VaR, ELM, additional surveillance margin',
      'Investor grievance redressal — SEBI SCORES portal',
      'AML/KYC — PMLA Act & compliance requirements',
      'SEBI regulations — intermediary registration & obligations',
      'Mock test preparation — NISM Series VII pattern',
    ],
  },
  {
    id: 7, category: 'NISM', level: 'Intermediate', badge: 'NISM Series I',
    title: 'Currency Derivatives Certification', hours: '40 Hours', type: 'Forex Practice',
    lang: 'Hindi + English', price: '₹8,999', chartType: 'area',
    desc: 'Foreign exchange markets, USD/INR currency futures & options, cross currency pairs, hedging strategies for importers/exporters and SEBI/RBI regulatory aspects.',
    syllabus: [
      'Introduction to foreign exchange markets — participants',
      'Exchange rate systems — fixed, floating, managed float',
      'Currency futures — USD/INR, EUR/INR, GBP/INR, JPY/INR',
      'Currency options — call, put, premiums, payoff profiles',
      'Cross currency pairs — EUR/USD, GBP/USD trading',
      'Hedging strategies for importers & exporters',
      'Arbitrage opportunities in currency markets',
      'Currency derivatives pricing — interest rate parity',
      'Trading & settlement on NSE currency segment',
      'RBI & SEBI regulations — FEMA, permitted currencies',
      'Risk management in currency derivatives',
      'Mock test preparation — NISM Series I pattern',
    ],
  },
];

//courses 68dfc485b67049dab0b21a1d65d0f6ad

const filters = ['All', 'NCFM', 'NISM', 'Institute', 'Beginner', 'Intermediate', 'Advanced'];

function Courses() {
  const [active, setActive] = useState('All');
  const [selectedCourse, setSelectedCourse] = useState(null);

  const filtered = courses.filter(c => {
    if (active === 'All') return true;
    return c.category === active || c.level === active;
  });

  const instituteFiltered = courses.filter(c =>
    c.category === 'Institute' &&
    (active === 'All' || active === 'Institute' || active === c.level)
  );

  const certFiltered = filtered.filter(c => c.category !== 'Institute');

  const showInstitute = ['All', 'Institute', 'Beginner', 'Intermediate'].includes(active);
  const showCert      = ['All', 'NCFM', 'NISM', 'Beginner', 'Intermediate', 'Advanced'].includes(active);
  const showDiploma   = ['All', 'NCFM', 'NISM', 'Advanced'].includes(active);

  return (
    <div className="courses">

      <section className="c-hero">
        <div className="c-hero-inner">
          <div className="c-tag">Our Courses</div>
          <h1>Industry Recognised <span>Market Education</span></h1>
          <div className="c-gold-line"></div>
          <p>From weekend beginner courses to advanced diplomas — structured learning paths aligned with SEBI, NISM and NCFM standards, guided by Himanshu Kumar.</p>
        </div>
      </section>

      <div className="c-filters">
        {filters.map(f => (
          <button key={f} className={`c-filter ${active === f ? 'active' : ''}`} onClick={() => setActive(f)}>
            {f}
          </button>
        ))}
      </div>

      {showInstitute && instituteFiltered.length > 0 && (
        <section className="c-section">
          <div className="c-subsection-header">
            <div className="c-subsection-badge">Stock Market Institute</div>
            <div className="c-subsection-desc">Weekend classroom courses · 3 months · Sasaram, Bihar</div>
          </div>
          <div className="c-grid">
            {instituteFiltered.map(course => (
              <div className="c-card" key={course.id}>
                <div className="c-card-top">
                  <div className="c-level">{course.level}</div>
                  <div className="c-badge c-badge-institute">{course.badge}</div>
                </div>
                <h3 className="c-card-title">{course.title}</h3>
                <p className="c-card-desc">{course.desc}</p>
                <div className="c-card-meta">
                  <span>📅 {course.hours}</span>
                  <span>🎯 {course.type}</span>
                  <span>🗣 {course.lang}</span>
                </div>
                <div className="c-card-footer">
                  <div className="c-price">{course.price} <span>/ 3 months</span></div>
                  <div className="c-card-btns">
                    <button className="c-detail-btn" onClick={() => setSelectedCourse(course)}>View Details</button>
                    <Link to={`/enquiry?course=${encodeURIComponent(course.title)}&badge=${encodeURIComponent(course.badge)}&price=${encodeURIComponent(course.price)}`} className="c-enrol-btn">Enrol Now</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {showCert && certFiltered.length > 0 && (
        <section className="c-section">
          <div className="c-subsection-header">
            <div className="c-subsection-badge">NCFM & NISM Certifications</div>
            <div className="c-subsection-desc">SEBI regulated · NSE & NISM recognised certifications</div>
          </div>
          <div className="c-grid">
            {certFiltered.map(course => (
              <div className="c-card" key={course.id}>
                <div className="c-card-top">
                  <div className="c-level">{course.level}</div>
                  <div className="c-badge">{course.badge}</div>
                </div>
                <h3 className="c-card-title">{course.title}</h3>
                <p className="c-card-desc">{course.desc}</p>
                <div className="c-card-meta">
                  <span>⏱ {course.hours}</span>
                  <span>🎯 {course.type}</span>
                  <span>🗣 {course.lang}</span>
                </div>
                <div className="c-card-footer">
                  <div className="c-price">{course.price} <span>/ lifetime</span></div>
                  <div className="c-card-btns">
                    <button className="c-detail-btn" onClick={() => setSelectedCourse(course)}>View Details</button>
                    <Link to={`/enquiry?course=${encodeURIComponent(course.title)}&badge=${encodeURIComponent(course.badge)}&price=${encodeURIComponent(course.price)}`} className="c-enrol-btn">Enrol Now</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      <section className="c-bundle-section">
        <div className="c-bundle">
          <div className="c-bundle-left">
            <div className="c-bundle-tag">⭐ Best Value</div>
            <h2 className="c-bundle-title">Complete Market Mastery Bundle</h2>
            <p className="c-bundle-desc">All 4 weekend courses + NISM/NCFM exam prep + 6 months personal mentorship with Himanshu Kumar. Weekend classes at Sasaram.</p>
            <div className="c-bundle-includes">
              <span>4 Weekend Courses</span><span>6 Months</span>
              <span>Weekend Classes</span><span>Live Sessions</span>
              <span>Mentorship</span><span>Community Access</span>
            </div>
          </div>
          <div className="c-bundle-right">
            <div className="c-bundle-price">₹29,999 <span>/ 6 months</span></div>
            <div className="c-bundle-save">Weekend classes · Sasaram, Bihar</div>
            <Link to="/enquiry?course=Complete%20Market%20Mastery%20Bundle&badge=Bundle&price=%E2%82%B929%2C999" className="c-bundle-btn">Get Full Bundle</Link>
          </div>
        </div>
      </section>

      {showDiploma && (
        <section className="c-section">
          <div className="c-diploma">
            <div className="c-diploma-left">
              <div className="c-diploma-tag">🎓 Advanced Diploma</div>
              <h2 className="c-diploma-title">Advanced Diploma in Stock Market & Financial Services</h2>
              <p className="c-diploma-desc">A comprehensive 1-year program covering all NCFM and NISM modules — from equity markets to derivatives, currency trading, technical & fundamental analysis.</p>
              <div className="c-diploma-modules">
                <div className="c-diploma-module-title">What's included:</div>
                <div className="c-diploma-modules-grid">
                  <span>✓ Capital Market Module (NCFM)</span>
                  <span>✓ Options Trading Strategies (NCFM)</span>
                  <span>✓ Technical Analysis (NCFM)</span>
                  <span>✓ Fundamental Analysis (NCFM)</span>
                  <span>✓ NISM Series VIII — Equity Derivatives</span>
                  <span>✓ NISM Series VII — Security Operations</span>
                  <span>✓ NISM Series I — Currency Derivatives</span>
                  <span>✓ Mutual Fund Investing</span>
                  <span>✓ Crypto Trading Basics</span>
                  <span>✓ Live Trading Sessions</span>
                  <span>✓ 1 Year Mentorship</span>
                  <span>✓ Placement Assistance</span>
                </div>
              </div>
            </div>
            <div className="c-diploma-right">
              <div className="c-diploma-price-box">
                <div className="c-diploma-price-tag">Total Program Fee</div>
                <div className="c-diploma-price">₹99,999</div>
                <div className="c-diploma-duration">1 Year · Weekend + Weekday Sessions</div>
                <div className="c-diploma-features">
                  <div className="c-diploma-feat">📜 NCFM + NISM Certifications</div>
                  <div className="c-diploma-feat">📊 Live Market Practice</div>
                  <div className="c-diploma-feat">👨‍🏫 Personal Mentorship</div>
                  <div className="c-diploma-feat">💬 WhatsApp Community</div>
                  <div className="c-diploma-feat">🏆 Certificate of Completion</div>
                  <div className="c-diploma-feat">💼 Placement Assistance</div>
                </div>
                <Link to="/enquiry?course=Advanced%20Diploma%20in%20Stock%20Market%20%26%20Financial%20Services&badge=Advanced%20Diploma&price=%E2%82%B999%2C999" className="c-diploma-btn">Apply for Diploma</Link>
              </div>
            </div>
          </div>
        </section>
      )}

      <section className="c-why">
        <div className="c-why-inner">
          <div className="c-tag" style={{textAlign:'center'}}>Why choose us</div>
          <h2 className="c-why-title">What makes us different</h2>
          <div className="c-why-grid">
            <div className="c-why-card">
              <div className="c-why-icon">🏛️</div>
              <div className="c-why-name">SEBI Aligned</div>
              <div className="c-why-desc">All courses follow SEBI & NISM guidelines, preparing you for official certification exams</div>
            </div>
            <div className="c-why-card">
              <div className="c-why-icon">📊</div>
              <div className="c-why-name">Live Market Sessions</div>
              <div className="c-why-desc">Learn with real market data in live sessions — not just theory but actual trading practice</div>
            </div>
            <div className="c-why-card">
              <div className="c-why-icon">📍</div>
              <div className="c-why-name">Physical Classes</div>
              <div className="c-why-desc">Weekend classroom sessions in Sasaram, Bihar</div>
            </div>
          </div>
        </div>
      </section>

      <section className="c-testi-section">
        <div className="c-testi-inner">
          <div className="c-tag" style={{textAlign:'center'}}>What students say</div>
          <h2 className="c-why-title">Real results from real students</h2>
          <div className="c-testi-grid">
            <div className="c-testi">
              <div className="c-stars">★★★★★</div>
              <p className="c-testi-text">"Cleared my NISM Series VIII in the first attempt thanks to Himanshu sir's structured approach. The live sessions made all the difference."</p>
              <div className="c-testi-author">Neha Kumari</div>
              <div className="c-testi-loc">📍 Delhi</div>
            </div>
            <div className="c-testi">
              <div className="c-stars">★★★★★</div>
              <p className="c-testi-text">"The Technical Analysis course completely changed how I read charts. Started making profitable trades within 3 months."</p>
              <div className="c-testi-author">Tripti Chauhan</div>
              <div className="c-testi-loc">📍 Mumbai</div>
            </div>
            <div className="c-testi">
              <div className="c-stars">★★★★★</div>
              <p className="c-testi-text">"Pehle stock market bilkul samajh nahi aata tha. Himanshu sir ne itna aasaan bana diya ki ab main khud apna portfolio manage karta hoon!"</p>
              <div className="c-testi-author">Arya Kumar</div>
              <div className="c-testi-loc">📍 Patna, Bihar</div>
            </div>
            <div className="c-testi">
              <div className="c-stars">★★★★★</div>
              <p className="c-testi-text">"Options trading course ne meri soch hi badal di. Sir ka teaching style bahut practical hai. NISM exam bhi clear ho gaya first try mein!"</p>
              <div className="c-testi-author">Kundan Kumar</div>
              <div className="c-testi-loc">📍 Hajipur, Bihar</div>
            </div>
          </div>
        </div>
      </section>

      {selectedCourse && (
        <CourseModal course={selectedCourse} onClose={() => setSelectedCourse(null)} />
      )}

    </div>
  );
}

export default Courses;